import { connect } from "react-redux";
import { getLoggedUserToken } from "../redux/selectors";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ButtonGroup, DropdownButton, Dropdown } from "react-bootstrap";

const SearchFilter = ({ data, categoryFilter, availableOnline }) => {
    const [Filters, setFilters] = useState([]);

    useEffect(() => {
        console.log("searchFilter.data:", data);
        console.log("searchFilter.availableOnline:", availableOnline);

        if (availableOnline)
            addFilter("ao_0", "Available Online");
        
        
    }, [data, availableOnline])

    const addFilter = (id, name) => {
        setFilters((prevFilters) => {
          // Check if the filter with the same id already exists
          if (prevFilters.some((filter) => filter.id === id)) {
            return prevFilters; 
          }

          return [...prevFilters, { id, name }];
        });
      };

      const removeFilter = (id) => {
        console.log(id);
        setFilters((prevFilters) => prevFilters.filter((filter) => filter.id !== id));
      };

    useEffect(() => {
        if (Filters!=null)
        {
            console.log("searchFilter.Filters:", Filters);

            categoryFilter(Filters);
        }
        
    }, [Filters])

    return (
        <div>
            <div className="badges mb-3">
                {/* <span class="badge badge-pill badge-light">Available Online <FontAwesomeIcon icon={faCheckCircle} /></span> */}
                <span className="pr-2"><button type="button" class="btn btn-outline-secondary"  onClick={() => addFilter("ao_0", "Available Online")}>Available Online</button></span>
                
                <ButtonGroup>
                    <DropdownButton as={ButtonGroup} title="Category" id="dropdownCat" variant="outline-secondary">
                        {data?.categories1.map((item, index) => (
                            <Dropdown.Item eventKey={item.id} onClick={() => addFilter("cat1_" + item.id, item.name)}>{item.name}</Dropdown.Item>
                            ))}
                    </DropdownButton>
                    <DropdownButton as={ButtonGroup} title="Sub-Category" id="dropdownCat2" variant="outline-secondary">
                        {data?.categories2.map((item, index) => (
                            <Dropdown.Item eventKey={item.id} onClick={() => addFilter("cat2_" + item.id, item.name)}>{item.name}</Dropdown.Item>
                            ))}
                    </DropdownButton>
                </ButtonGroup>
            </div>
            {/* <span class="badge badge-pill badge-light">Available Online <FontAwesomeIcon icon={faTimes}/></span> */}
            {/* <a href="#" class="badge badge-pill badge-secondary">Available Online <FontAwesomeIcon icon={faTimes} className="ml-1"/></a> */}
            {Filters.map((filter) => (
                <a key={filter.id}
                    href="#"
                    className="badge badge-pill badge-secondary mx-1"
                    onClick={() => removeFilter(filter.id)}
                >
                    {filter.name}
                <FontAwesomeIcon icon={faTimes} className="ml-1" />
                </a>
            ))}
        </div>
    );
}

const mapStateToProps = store => {
    const userToken = getLoggedUserToken(store);
    return { userToken };
}

export default connect(mapStateToProps)(SearchFilter);